import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import CommentDataAttrDiv from '../../../../lego/CommentDataAttrDiv';
import s from './RootLayout.scss';
const RootLayout = (_param)=>{
    var { className, contentBlocks, prefix } = _param, rest = _object_without_properties(_param, [
        "className",
        "contentBlocks",
        "prefix"
    ]);
    return /*#__PURE__*/ React.createElement(CommentDataAttrDiv, _object_spread({
        className: c(s['root'], className)
    }, rest), prefix, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, contentBlocks));
};
RootLayout.displayName = 'RootLayout';
export default RootLayout;
